import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { handleRequestError, handleRequestSuccess } from "utils/Request";

async function resetRoundRobinWeights(categoryId?: string) {
  return api.post('/support/agents/reset-weights', categoryId ? { category_id: categoryId } : {});
}

export function useResetRoundRobinWeights() {
  const queryClient = useQueryClient();

  return useMutation((categoryId?: string) => resetRoundRobinWeights(categoryId), {
    onSuccess: () => {
      handleRequestSuccess('Rodízio reiniciado com sucesso!');
      queryClient.invalidateQueries('support-agents');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao reiniciar o rodizio. Tente novamente.');
    },
  });
}
